import { animateHeroElement } from './helpers';

export const teamHeroAnimation = () => {
	animateHeroElement(
		'.team-hero-image-left',
		{ rotate: -10 },
		{
			rotate: 0,
			x: 34,
			y: 22,
			duration: 1.5,
			ease: 'imageEasing',
		}
	);

	animateHeroElement(
		'.team-hero-left-square',
		{
			rotate: -10,
		},
		{
			rotate: 0,
			x: 37,
			y: 14,
			duration: 1,
			delay: 0.5,
			ease: 'imageEasing',
		}
	);

	animateHeroElement(
		'.team-hero-left-circle',
		{},
		{
			x: 27,
			y: 41,
			duration: 1,
			delay: 0.5,
			ease: 'smoothEasing',
		}
	);

	animateHeroElement(
		'.team-hero-image-right',
		{ rotate: -10 },
		{
			rotate: 0,
			x: -59,
			y: -57,
			duration: 1.5,
			ease: 'imageEasing',
		}
	);

	animateHeroElement(
		'.team-hero-right-square',
		{ rotate: -10 },
		{
			rotate: 10,
			x: -30,
			y: -63,
			duration: 1,
			delay: 0.5,
			ease: 'smoothEasing',
		}
	);
};
